export const StatusSharedCssClassName = {
  STATUS_CONTAINER: 'statusView-content-wrap',
  STATUS_LOZENGE: 'status-lozenge-span'
};